import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect } from 'react'

import { ZENDESK_KEY, ZENDESK_SCRIPT_URL } from '../../../constants/config'
import { useAuth } from '../../../context/auth'
import { useLocales } from '../../../context/locales'
import useScript from '../../../hooks/use-script'
import { getUserProfileText } from '../../../util/profile'

function getZendeskScriptUrl() {
  return `${ZENDESK_SCRIPT_URL}?key=${ZENDESK_KEY}`
}

type SupportWidgetProps = {
  onCloseModal?: () => void
  isModal?: boolean
}

export const ZendeskSupportView = ({ onCloseModal, isModal = false }: SupportWidgetProps) => {
  const status = useScript(getZendeskScriptUrl(), { srcAttrs: { id: 'ze-snippet' } })

  const { profile } = useAuth()
  const { currentLanguage } = useLocales()
  const navigation = useNavigation()

  useEffect(() => {
    if (window.zE !== undefined) {
      window.zE('webWidget', 'open')
      window.zE('webWidget', 'setLocale', currentLanguage.toLowerCase())
      window.zE('webWidget:on', 'close', () => {
        if (isModal) {
          window.zE?.('webWidget', 'close')
          window.zE?.('webWidget', 'hide')
          if (onCloseModal) {
            onCloseModal()
          }
        } else {
          if (navigation.canGoBack()) {
            navigation.goBack()
          } else {
            navigation.navigate('Main', { screen: 'HomeTab' })
          }
        }
      })
    }
    // currentLanguage is omitted intentionally
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status])

  useEffect(() => {
    window.zE?.('webWidget', 'setLocale', currentLanguage.toLowerCase())
  }, [currentLanguage])

  useEffect(() => {
    if (profile) {
      window.zE?.('webWidget', 'prefill', {
        name: { value: getUserProfileText({ user: profile }) },
        email: { value: profile.email },
      })
    }

    return () => {
      window.zE?.('webWidget', 'logout')
    }
  }, [profile])

  const isFocused = useIsFocused()

  useEffect(() => {
    if (typeof window === 'undefined') return

    if (isFocused) {
      window.zE?.('webWidget', 'open')
      window.zE?.('webWidget', 'show')
    } else {
      window.zE?.('webWidget', 'hide')
    }
  }, [isFocused])

  return null
}
